import { setColaboradorAcessos } from '../utils/storage';
import http from '../utils/api';

export function getColaboradorAcessos() {
    return http.get('colaborador/acessos', {}).then( async ({data}) => {
        setColaboradorAcessos(data ?? []);
    }).catch(async () => {
        setColaboradorAcessos([]);
    });
}
